// theme.js's native <product-recommendations> element resolves the section id for its fetch via
// this.closest('.shopify-section') — but <cart-drawer> gets moved to document.body when opened (see
// the Drawer base class's attributeChangedCallback in theme.js, which does document.body.append(this)
// to escape stacking-context clipping). Once that happens, every product-recommendations element
// created inside the drawer afterward (e.g. after adding/removing an item, since cart:change replaces
// the drawer's children with fresh markup) has no .shopify-section ancestor to find. The native lookup
// throws synchronously before it ever calls fetch, so the request never appears in the network tab and
// the upsell silently stays empty. This replicates the same fetch-and-inject logic using a section id
// baked in via a data attribute at render time instead of a DOM-tree lookup that can't work once
// detached.
(function () {
  function loadFallback(el, sectionId) {
    if (el.dataset.fallbackAttempted) {
      return;
    }

    el.dataset.fallbackAttempted = 'true';

    const productId = el.getAttribute('product');
    const limit = el.getAttribute('limit') || 4;
    const intent = el.getAttribute('intent') || 'related';
    const url = `${Shopify.routes.root}recommendations/products?product_id=${productId}&limit=${limit}&section_id=${sectionId}&intent=${intent}`;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const tempDiv = new DOMParser().parseFromString(html, 'text/html');
        const recommendationsEl = tempDiv.querySelector('product-recommendations');

        if (recommendationsEl && recommendationsEl.childElementCount > 0) {
          el.replaceChildren(...document.importNode(recommendationsEl, true).childNodes);
          el.hidden = false;
        } else {
          el.remove();
        }
      })
      .catch((error) => {
        console.error('[cart-drawer-recommendations-fallback]', error);
      });
  }

  function scan() {
    document.querySelectorAll('.cart-drawer__complementary-products[data-section-id]').forEach((container) => {
      const sectionId = container.getAttribute('data-section-id');

      container.querySelectorAll('product-recommendations[hidden]').forEach((el) => {
        // Only step in when the native lookup structurally cannot succeed (no section ancestor at
        // all) — never a guess/race against the native element, since it only fails to find an
        // ancestor in exactly the detached-drawer case this script exists to cover.
        if (!el.closest('.shopify-section')) {
          loadFallback(el, sectionId);
        }
      });
    });
  }

  scan();

  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
